import { useState, useEffect, useRef } from "react";

export default function TestFilters({ individualTestCount, packagesCount, onFilterChange }) {
  //const [priceRange, setPriceRange] = useState(10000)
  const [selectedTypes, setSelectedTypes] = useState([]);
  const [priceOrder, setPriceOrder] = useState("");
  const [locationOrder, setLocationOrder] = useState("");

  useEffect(() => {
    onFilterChange({
      types: selectedTypes,
      priceOrder,
      locationOrder,
    });
  }, [selectedTypes, priceOrder, locationOrder]);

  const handleTypeChange = (type) => {
    setSelectedTypes((prev) =>
      prev.includes(type) ? prev.filter((t) => t !== type) : [...prev, type]
    );
  };

  const handleSortChange = (e) => {
    setPriceOrder(e.target.value);
  };

  const handleSortChangelocation = (e) => {
    setLocationOrder(e.target.value);
  };

  return (
    <div className="bg-white p-5 rounded-lg border border-[#E0E0E0] sticky top-24">
      <h2 className="text-lg font-semibold text-[#4A4A4A] mb-5">Filter by</h2>

      <div className="mb-6">
        <h3 className="text-base font-medium text-[#4A4A4A] mb-3">Test Type</h3>
        <div className="space-y-2">
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={selectedTypes.includes("Labtests")}
              onChange={() => handleTypeChange("Labtests")}
              className="w-4 h-4 rounded border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">Single Test ({individualTestCount})</span>
          </label>
          <label className="flex items-center">
            <input
              type="checkbox"
              checked={selectedTypes.includes("Packages")}
              onChange={() => handleTypeChange("Packages")}
              className="w-4 h-4 rounded border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">Package ({packagesCount})</span>
          </label>
        </div>
      </div>

      {/* Test Type */}
      {/* <label className="flex items-center">
        <input
          type="checkbox"
          checked={selectedTypes.includes("Labtests")}
          onChange={() => handleTypeChange("Labtests")}
          className="w-4 h-4 rounded border-gray-300 text-[#951C25] focus:ring-[#951C25]"
        />
        <span className="ml-2 text-sm text-[#4A4A4A]">
          Single Test ({individualTestCount})
        </span>
      </label>

      <label className="flex items-center">
        <input
          type="checkbox"
          checked={selectedTypes.includes("Packages")}
          onChange={() => handleTypeChange("Packages")}
          className="w-4 h-4 rounded border-gray-300 text-[#951C25] focus:ring-[#951C25]"
        />
        <span className="ml-2 text-sm text-[#4A4A4A]">
          Package ({packagesCount})
        </span>
      </label> */}


      {/* Fasting Type */}
      {/* <div className="mb-6">
        <h3 className="text-base font-medium text-[#4A4A4A] mb-3">Fasting Type</h3>
        <div className="space-y-2">
          <label className="flex items-center">
            <input type="checkbox" className="w-4 h-4 rounded border-gray-300 text-[#951C25] focus:ring-[#951C25]" />
            <span className="ml-2 text-sm text-[#4A4A4A]">Fasting</span>
          </label>
          <label className="flex items-center">
            <input type="checkbox" className="w-4 h-4 rounded border-gray-300 text-[#951C25] focus:ring-[#951C25]" />
            <span className="ml-2 text-sm text-[#4A4A4A]">No Fasting</span>
          </label>
        </div>
      </div> */}

      {/* Price Range */}
      {/* <div className="mb-6">
        <h3 className="text-base font-medium text-[#4A4A4A] mb-3">Price</h3>
        <h4 className="text-sm text-[#4A4A4A] mb-2">Price Range</h4>
        <div className="mb-2">
          <input
            type="range"
            min="0"
            max="10000"
            step="100"
            value={priceRange}
            onChange={(e) => setPriceRange(Number.parseInt(e.target.value))}
            className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer"
          />
        </div>
        <div className="flex justify-between text-xs text-[#4A4A4A]/70">
          <span>₹0</span>
          <span>₹{priceRange}</span>
        </div>
      </div> */}

      {/* Sort By */}
      <div>
        <h3 className="text-base font-medium text-[#4A4A4A] mb-3">Sort By</h3>
        <div className="space-y-2">
          <label className="flex items-center">
            <input
              type="radio"
              name="sort"
              value="low_to_high"
              checked={priceOrder === "low_to_high"}
              onChange={handleSortChange}
              className="w-4 h-4 border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">Price: Low to High</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="sort"
              value="high_to_low"
              checked={priceOrder === "high_to_low"}
              onChange={handleSortChange}
              className="w-4 h-4 border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">Price: High to Low</span>
          </label>
          {/* <label className="flex items-center">
            <input
              type="radio"
              name="sort"
              value="discount_low_high"
              className="w-4 h-4 border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">Discount: Low to High</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="sort"
              value="discount_high_low"
              className="w-4 h-4 border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">Discount: High to Low</span>
          </label> */}
        </div>
      </div>

      <div>
        <h3 className="text-base font-medium text-[#4A4A4A] mt-4 mb-3">Location Preference </h3>
        <div className="space-y-2">
          <label className="flex items-center">
            <input
              type="radio"
              name="sort_location"
              value="at_home"
              checked={locationOrder === "at_home"}
              onChange={handleSortChangelocation}
              className="w-4 h-4 border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">At Home</span>
          </label>
          <label className="flex items-center">
            <input
              type="radio"
              name="sort_location"
              value="at_lab"
              checked={locationOrder === "at_lab"}
              onChange={handleSortChangelocation}
              className="w-4 h-4 border-gray-300 text-[#951C25] focus:ring-[#951C25]"
            />
            <span className="ml-2 text-sm text-[#4A4A4A]">At Diagnostic Center</span>
          </label>
        </div>
      </div>
    </div>
  )
}

